import { c as _c } from "react/compiler-runtime";
import React, { type JSX } from "react";
interface PermissionIconProps {
  readonly className?: string;
}

/**
 * Icon indicating permission or eligibility status
 * Uses a lock symbol to represent access restriction
 */
export default function PermissionIcon(t0) {
  const $ = _c(5);
  const {
    className: t1
  } = t0;
  const className = t1 === undefined ? "" : t1;
  let t2;
  let t3;
  let t4;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <rect x="5" y="11" width="14" height="10" rx="2" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />;
    t3 = <path d="M8 11V7C8 4.79086 9.79086 3 12 3C14.2091 3 16 4.79086 16 7V11" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />;
    t4 = <circle cx="12" cy="16" r="1" fill="currentColor" />;
    $[0] = t2;
    $[1] = t3;
    $[2] = t4;
  } else {
    t2 = $[0];
    t3 = $[1];
    t4 = $[2];
  }
  let t5;
  if ($[3] !== className) {
    t5 = <svg className={className} viewBox="0 0 24 24" fill="none" aria-hidden="true" xmlns="http://www.w3.org/2000/svg">{t2}{t3}{t4}</svg>;
    $[3] = className;
    $[4] = t5;
  } else {
    t5 = $[4];
  }
  return t5;
}